import MerchantProfilesService from "@/api/services/merchantProfiles";
import { toCamelCase } from "@estaly/ui";

const initialState = {
  index: [],
  currentPage: 1,
  totalPages: 0,
  totalCount: 0,
};

export default {
  namespaced: true,
  state: initialState,
  mutations: {
    setIndex(state, data) {
      state.index = data.records;
      state.currentPage = data.page.currentPage || 1;
      state.totalPages = data.page.totalPages || 0;
      state.totalCount = data.page.totalCount || 0;
    },
  },
  actions: {
    async fetchIndex({ commit }, { keywords, storeIds, page, includes } = {}) {
      const response = await MerchantProfilesService.fetchIndex({ keywords, storeIds, page, includes });
      if (!response?.success) return response;

      const data = toCamelCase(response.data);
      commit("setIndex", data);
      return data;
    },
    async delete(_, id) {
      const response = await MerchantProfilesService.delete(id);
      return response?.success;
    },
    async update(_, params) {
      const { id, ...data } = params;
      const response = await MerchantProfilesService.update(id, data);
      return response?.success;
    },
    async new() {
      const response = await MerchantProfilesService.new();
      return response?.success ? toCamelCase(response.data) : null;
    },
    async create(_, params) {
      const response = await MerchantProfilesService.create(params);
      return response?.success;
    },
  },
};
